import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './musicmemory.json'; // The JSON you provided

const Musicmemory = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Music psychology, memory, and cultural vocabulary. B2 English exercises with grammar, reading, and listening practice."
            level="B2"
            title="Memory"
            image="/Images/memory.webp"
            seoTitle="Free English Lesson Plans: Music and Memory"
            seoDescription="Music psychology, memory, and cultural vocabulary. B2 English exercises with grammar, reading, and listening practice."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Musicmemory;


